<h1 class="stock-title">Stock Unit Search - Natis Documentation</h1>


<!-- Spacer -->
<br /><br />

<div style="display: flex; gap: 1rem">
  <ds-form-field>
    <input ds-input id="Search" size="md" type="text" placeholder="Enter search term" [(ngModel)]="searchTerm" />
  </ds-form-field>
 <ds-button type="button" appearance="primary" size="md" (click)="onSearch()">
   <span style="display: flex; align-items: center; gap: 0.5rem;">
     <ds-icon icon="search" size="sm"></ds-icon>
     <span>Search</span>
   </span>
 </ds-button>
</div>

<!-- Spacer -->
<br />
<br />
<div class="content_bg styled-section">
  <div class="mt-3"></div>

  <table class="ds-table zebra-table">
    <thead>
      <tr>
<!--        <th>Image</th>-->
        <th>VIN</th>
        <th>Invoice</th>
        <th>Model</th>
        <th>Interior</th>
        <th>Exterior</th>
        <th>Released</th>
        <th>View Info</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of filteredRows">
<!--          @if (row['image'] === '') {-->
<!--              <ds-progress-circle-->
<!--                      size="sm"-->
<!--                      class="image-loader"-->
<!--              ></ds-progress-circle>-->
<!--          } @else {-->
<!--        <div class="image-popup-wrapper">-->
<!--          <img-->
<!--            [src]="row['image'] || 'image placeholder'"-->
<!--            alt="Image"-->
<!--            width="80"-->
<!--          />-->
<!--          <div class="image-hover-popup">-->
<!--            <img [src]="row['image']" alt="Vehicle Enlarged View" />-->
<!--          </div>-->
<!--        </div>-->
<!--          }-->
        <td>
          <a
            [href]="row['zvin'] | unitOverviewLink"
            target="_blank"
            rel="noopener"
            style="
              font-weight: bold;
              color: #037493;
              text-decoration: none;
              cursor: pointer;
            "
            title="View Unit Overview"
            >{{ row['zvin'] }}</a
          >
        </td>
        <td>{{ row['zinvoice'] }}</td>
        <td>{{ row['model'] }}</td>
        <td>{{ row['interior'] }}</td>
        <td>{{ row['exterior'] }}</td>
        <td>{{ row['view'] }}</td>
        <td>
          <span title="Download Document">
            <ds-icon
              icon="download"
              size="sm"
              class="download-icon"
              [disabled]="row['zreleased'] !== 'X'"
              (click)="downloadDocument(row['zvin'])"
            ></ds-icon>
          </span>
        </td>
        <td>
          <button
            ds-button
            [disabled]="row['zreleased'] !== ''"
            (click)="releaseVehicle(row['zvin'])"
            class="release-btn"
          >
            Release
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
